/**
 * The long-form docs behind a settings row's "want to know more" pill.
 *
 * One markdown document per topic, gathered here rather than beside whichever modal happens to show
 * it: they are copy about features, they change on their own schedule, and a set of them is far
 * easier to find and review in one folder than scattered through the components.
 */
// Imported with the full `.md.js` extension: written as `./smartScroll.md` it would resolve, but
// only by falling through to the .js the resolver tries second, which reads like a mistake.
import smartScrollEn from './smartScroll.md.js';
import smartScrollEs from './smartScroll.es.md.js';

// Each doc by language; docFor picks one, falling back to English
export const smartScrollDoc = { en: smartScrollEn, es: smartScrollEs };

export const docFor = (doc, language) => doc[language] || doc.en;
